import axios from 'axios';

import * as storeTypes from './document.store-types';
import {Document} from './models/document.models';

export default {
    namespaced: true,
    state: {
        isActiveRequest: false,
        isLoading: false,
        selectedCategoryId: '',
        currentDocument: new Document,
    },
    mutations: {
        [storeTypes.SET_IS_ACTIVE_REQUEST]: (state, isActiveRequest) => state.isActiveRequest = isActiveRequest,
        [storeTypes.SET_IS_LOADING]: (state, isLoading) => state.isLoading = isLoading,
        [storeTypes.SET_SELECTED_CATEGORY_ID]: (state, selectedCategoryId) => state.selectedCategoryId = selectedCategoryId,
        [storeTypes.SET_CURRENT_DOCUMENT]: (state, currentDocument) => state.currentDocument = currentDocument,
    },
    actions: {
        async [storeTypes.ACTION_GET_DOCUMENT](store, {documentId}) {
            store.commit(storeTypes.SET_IS_LOADING, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, error, document}} = await axios.get(`/api/documents/${documentId}`);

                        if (!success) {
                            return reject(error);
                        }

                        store.commit(storeTypes.SET_CURRENT_DOCUMENT, Document.fromArray(document));
                        resolve(store.state.currentDocument);
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_LOADING, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_ADD_DOCUMENT](store, {document}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.post(`/api/categories/${store.state.selectedCategoryId}/documents`, {document});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_UPDATE_DOCUMENT](store, {document}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.put(`/api/documents/${document._id}`, {document});

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_REMOVE_DOCUMENT](store, {documentId}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success}} = await axios.delete(`/api/documents/${documentId}`);

                        if (success) {
                            return resolve();
                        }
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
        async [storeTypes.ACTION_FINISH_TEST](store, {documentId, answeredQuestionsPath = null}) {
            store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, true);

            return new Promise((resolve, reject) => {
                (async () => {
                    try {
                        const {data: {success, document, error}} = await axios.post(`/api/documents/${documentId}/finish-test`, {
                            answeredQuestionsPath
                        });

                        if (!success) {
                            return reject(error);
                        }

                        store.commit(storeTypes.SET_CURRENT_DOCUMENT, Document.fromArray(document));
                        resolve();
                    } catch ({response: {data: {error}}}) {
                        reject(error);
                    } finally {
                        store.commit(storeTypes.SET_IS_ACTIVE_REQUEST, false);
                    }
                })();
            });
        },
    },
    getters: {
        [storeTypes.GET_IS_ACTIVE_REQUEST]: state => state.isActiveRequest,
        [storeTypes.GET_IS_LOADING]: state => state.isLoading,
        [storeTypes.GET_CURRENT_DOCUMENT]: state => state.currentDocument,
    },
}